import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_USERS } from "./apiRoutes";

interface UseGetUserProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const downloadUserProfile = async (communityId: string) =>
  await axiosAuth.get(`${GET_USERS}/me/profile/pdf?communityId=${communityId}`, {
    responseType: "blob",
  });

const useDownloadUserProfile = ({
  communityId,
  queryParams
}: UseGetUserProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["user-profile-pdf"],
    queryFn: () => downloadUserProfile(communityId),
    select: (data: any) => data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useDownloadUserProfile;
